module.exports = __webpack_public_path__ + "static/media/waiting.0d6f4718.svg";